module.exports = __webpack_public_path__ + "img/DE.02cdf8de.svg";